import { cn } from '@strivelabs/ui-core/lib/utils';

/**
 * The task glyph, verbatim from the artifact (`TICON` — a checked list):
 * drawn rather than picked from the icon set, so the board, the homepage
 * section and the empty state all carry the same mark.
 */
export const TaskGlyph = ({ className }: { className?: string }) => (
  <svg
    viewBox="1.48 1.73 20.24 20.24"
    className={cn('size-4 shrink-0 fill-none stroke-current stroke-[1.8]', className)}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M9 6h11M9 12h11M9 18h11" />
    <path d="M3.5 5.5l1 1 1.6-1.8" />
    <circle cx="4.2" cy="12" r="1" />
    <circle cx="4.2" cy="18" r="1" />
  </svg>
);
